import { register } from "./adyen-card-provider";

register();

